// extracted by mini-css-extract-plugin
export default {"sidebarToggle":"sidebarToggle_sidebarToggle__RjtWb"};